// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"Layout_mainTitle__1q-OT","hover-ripples":"Layout_hover-ripples__3S9Ug"};